import { Link } from 'react-router';

import { featureConfig } from '../../../common/featureConfig';
import { devRouteConfig } from '../../getDevRoutes';
import { useTestLinkStyles } from './useTestLinkStyles';

/**
 * for testing purpose only
 */
export function TestLink(): JSX.Element {
  const { classes } = useTestLinkStyles();

  return (
    <div className={classes.root}>
      <Link
        className={classes.menuLink}
        title="Testing only"
        to={devRouteConfig.dev.generatePath()}
      >
        🧪 Test menu
      </Link>

      {featureConfig.offlineTesting && (
        <span>⚠️ Offline testing is enabled</span>
      )}
    </div>
  );
}
